module.exports = function(exec){
  try {
    exec();
    return false;
  } catch(e){
    return true;
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.throws.js
 ** module id = 96
 ** module chunks = 0
 **/